
import Chart3 from "../../../assets/outline/Chart3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Chart3Icon({ className, dataTestid = "Chart3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Chart3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
